import { ThreeCircles } from 'react-loader-spinner';

const LoaderCustom = (props) => {
    return (
        <ThreeCircles
            height="100"
            width="100"
            color=""
            
            wrapperClass=""
            visible={true}
            ariaLabel="three-circles-rotating"
            outerCircleColor="#94CC00"
            innerCircleColor="#BFBDC1"
            middleCircleColor="#AD001A"
            wrapperStyle={{
                position:"absolute",
                top:"50%",
                left:"50%"
            }}
            
        />
    )
}

export default LoaderCustom;